import { motion } from 'framer-motion';
import type { QuestionDefinition } from '../../../../types/checkin';

interface ScaleQuestionProps {
  question: QuestionDefinition;
  value: number | undefined;
  onChange: (value: number) => void;
}

export function ScaleQuestion({
  question,
  value,
  onChange,
}: ScaleQuestionProps) {
  const numbers = Array.from({ length: 10 }, (_, i) => i + 1);

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-5 gap-2">
        {numbers.map((num) => {
          const isSelected = value === num;

          return (
            <button
              key={num}
              onClick={() => onChange(num)}
              className="relative aspect-square flex items-center justify-center text-lg font-medium rounded-lg border-2 transition-colors"
              style={{
                borderColor: isSelected ? 'var(--color-accent-500)' : 'var(--color-neutral-200)',
                backgroundColor: isSelected ? 'var(--color-accent-500)' : 'transparent',
                color: isSelected ? 'white' : 'var(--color-neutral-700)',
              }}
            >
              {isSelected && (
                <motion.div
                  layoutId="scale-selection"
                  className="absolute inset-0 rounded-lg"
                  style={{
                    backgroundColor: 'var(--color-accent-500)',
                  }}
                  transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                />
              )}
              <span className="relative z-10">{num}</span>
            </button>
          );
        })}
      </div>

      {question.scaleLabels && (
        <div className="flex justify-between text-xs text-neutral-500">
          <span>{question.scaleLabels.min}</span>
          <span>{question.scaleLabels.max}</span>
        </div>
      )}
    </div>
  );
}
